import { createBrowserRouter, Navigate, useLocation } from 'react-router-dom';
import { AuthLayout } from './components/layout/AuthLayout';
import { AppLayout } from './components/layout/AppLayout';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { PublicRoute } from './components/auth/PublicRoute';

// Auth pages
import { LoginPage } from './pages/auth/LoginPage';
import { RegisterPage } from './pages/auth/RegisterPage';
import { RegisterSelectPage } from './pages/auth/RegisterSelectPage';
import { ForgotPasswordPage } from './pages/auth/ForgotPasswordPage';
import { VerifyEmailPage } from './pages/auth/VerifyEmailPage';
import { AuthActionPage } from './pages/auth/AuthActionPage';
import { ImpersonatePage } from './pages/auth/ImpersonatePage';

// App pages
import { DashboardPage } from './pages/dashboard/DashboardPage';
import { MyPage } from './pages/mypage/MyPage';
import { ProfileEditPage } from './pages/profile/ProfileEditPage';
import { VerificationPage } from './pages/profile/VerificationPage';
import { SearchPage } from './pages/search/SearchPage';
import { AccessRequestsPage } from './pages/requests/AccessRequestsPage';
import { MessagesPage } from './pages/messages/MessagesPage';
import { ReviewsPage } from './pages/reviews/ReviewsPage';
import { NotificationSettingsPage } from './pages/settings/NotificationSettingsPage';
import { AccountSettingsPage } from './pages/settings/AccountSettingsPage';
import { ContactPage } from './pages/settings/ContactPage';
import { WithdrawPage } from './pages/settings/WithdrawPage';
import { NotFoundPage } from './pages/NotFoundPage';

function LegacyReviewsRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/mypage/reviews${search}`} replace />;
}

function LegacyRequestsRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/mypage/requests${search}`} replace />;
}

export const router = createBrowserRouter([
  {
    path: '/impersonate',
    element: <ImpersonatePage />,
  },
  // Public routes (Auth pages)
  {
    element: <PublicRoute />,
    children: [
      {
        element: <AuthLayout />,
        children: [
          {
            path: '/login',
            element: <LoginPage />,
          },
          {
            path: '/register',
            element: <RegisterSelectPage />,
          },
          {
            path: '/register/:role',
            element: <RegisterPage />,
          },
          {
            path: '/forgot-password',
            element: <ForgotPasswordPage />,
          },
        ],
      },
    ],
  },
  // Semi-protected route (needs auth but not necessarily verified)
  {
    path: '/verify-email',
    element: <VerifyEmailPage />,
  },
  {
    path: '/auth/action',
    element: <AuthActionPage />,
  },
  // Protected routes (App pages)
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <AppLayout />,
        children: [
          {
            path: '/',
            element: <Navigate to="/dashboard" replace />,
          },
          {
            path: '/dashboard',
            element: <DashboardPage />,
          },
          // マイページ (旧プロフィール + 設定)
          {
            path: '/mypage',
            element: <MyPage />,
          },
          {
            path: '/mypage/edit',
            element: <ProfileEditPage />,
          },
          {
            path: '/mypage/verification',
            element: <VerificationPage />,
          },
          {
            path: '/mypage/notifications',
            element: <NotificationSettingsPage />,
          },
          {
            path: '/mypage/account',
            element: <AccountSettingsPage />,
          },
          {
            path: '/mypage/contact',
            element: <ContactPage />,
          },
          {
            path: '/mypage/withdraw',
            element: <WithdrawPage />,
          },
          {
            path: '/mypage/reviews',
            element: <ReviewsPage />,
          },
          {
            path: '/mypage/requests',
            element: <AccessRequestsPage />,
          },
          // 検索
          {
            path: '/search',
            element: <SearchPage />,
          },
          {
            path: '/donors/:donorId',
            element: <Navigate to="/search" replace />,
          },
          // 閲覧申請
          {
            path: '/requests',
            element: <LegacyRequestsRedirect />,
          },
          // メッセージ (チャットはBottomSheetで表示)
          {
            path: '/messages',
            element: <MessagesPage />,
          },
          // レビュー
          {
            path: '/reviews',
            element: <LegacyReviewsRedirect />,
          },
          // 旧ルートのリダイレクト
          {
            path: '/profile',
            element: <Navigate to="/mypage" replace />,
          },
          {
            path: '/profile/edit',
            element: <Navigate to="/mypage/edit" replace />,
          },
          {
            path: '/profile/verification',
            element: <Navigate to="/mypage/verification" replace />,
          },
          {
            path: '/settings',
            element: <Navigate to="/mypage" replace />,
          },
          {
            path: '/settings/notifications',
            element: <Navigate to="/mypage/notifications" replace />,
          },
          {
            path: '/settings/account',
            element: <Navigate to="/mypage/account" replace />,
          },
          {
            path: '/settings/withdraw',
            element: <Navigate to="/mypage/withdraw" replace />,
          },
        ],
      },
    ],
  },
  // 404
  {
    path: '*',
    element: <NotFoundPage />,
  },
]);
